import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2022-09-30T11:00",
		title: `
<h4>しばた地域医療介護連携センターより</h4>
<p class="paragraph-indent">
●令和4年度医療・介護関係者の研修「つなぐ会」開催のご案内<br>
・<a href="${topicsDir}/2022/09-shibata-tsunagukai_youkou.pdf">研修会案内/開催要綱</a><br>
・<a href="${topicsDir}/2022/09-shibata-tsunagukai_moushikomi.pdf">チラシ/申込用紙</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
